'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/calendar/CalendarIcon.tsx
import { jsx } from "react/jsx-runtime";
var CalendarIcon = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    __spreadProps(__spreadValues({
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2 2H14V14H2V2ZM3.33333 3.33333V4.66667H12.6667V3.33333H3.33333ZM12.6667 6H3.33333V12.6667H12.6667V6ZM4.66667 7.33333H6.00667V8.66667H4.66667V7.33333ZM7.33333 7.33333H8.67333V8.66667H7.33333V7.33333ZM10 7.33333H11.34V8.66667H10V7.33333ZM4.66667 10H6.00667V11.3333H4.66667V10ZM7.33333 10H8.67333V11.3333H7.33333V10Z",
          fill: "currentColor"
        }
      )
    })
  );
};

export {
  CalendarIcon
};
//# sourceMappingURL=chunk-252V44DG.mjs.map